<template>
  <div>
    <v-btn v-if="provider.settings.allow_public_scheduling"
           color="primary"
           depressed
           :fab="$vuetify.breakpoint.smAndDown"
           rounded
           dark
           @click="openScheduling"
    >
      <v-icon :left="$vuetify.breakpoint.mdAndUp">fa-calendar-alt</v-icon>
      <span v-if="$vuetify.breakpoint.mdAndUp">Agendar cita</span>
    </v-btn>

    <appointment-provider-stepper
        v-if="provider"
        ref="stepper"
        :disable-close-modal="disableCloseModal"
        :redirect-url="redirectUrl"
        :service-provider="provider"
        :internal="false"
    />

</div>
</template>

<script>
import AppointmentProviderStepper from "@/components/appointments/AppointmentProviderStepper";
export default {
name: "AppointmentPicker",
  components: {AppointmentProviderStepper},
  props:{
    provider: {
      type: Object,
      required: true
    },
    startOnLoad: {
      type: Boolean,
      default: false
    },
    disableCloseModal: {
      type: Boolean,
      default: false
    },
    redirectUrl: {
      type: String,
      default: ''
    }
  },
  mounted(){
    const vm = this
    if(vm.startOnLoad){
      vm.openScheduling()
    }
  },
  methods: {
    openScheduling() {
      const vm = this
      return vm.$refs.stepper && vm.$refs.stepper.show()
    },
  },
  watch:{
    startOnLoad(val){
      if(val) this.openScheduling()
    }
  }
}
</script>

<style scoped>

</style>
